export const BuildingDepartmentURLs = {
    listView: '/building-departments',
    detailsView: '/building-departments/:buildingDepartmentId',
    addView: '/building-departments/add',
    editView: '/building-departments/:id/edit',
}